/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class NotificationPolicyConfigSns {
  /**
  * The topic ARN to send the notification to
  */
  'topicArn'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "topicArn",
      "baseName": "topicArn",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotificationPolicyConfigSns.attributeTypeMap;
  }

  public constructor() {
  }
}

